<template>
	<div>
		<div class="container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light mb-4 mt-2">
				<h1 class="h3 mb-0 text-gray-800 mr-4">
					Financeiro
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarFinanceiroGeral" 
					aria-controls="navbarFinanceiroGeral" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse mt-4" id="navbarFinanceiroGeral">
			  		<div class="form-row">
						<div class="form-group col-md-12">
							<input-date 
								time="1000"
								@date="setDate">
							</input-date>
						</div>
					</div>
			  	</div>
			</nav>
			<financeiro-caixa
				v-if="date"
				:key="financeiroCaixaKey"
				:date="date">
			</financeiro-caixa>
			<financeiro-valores
				v-if="date"
				:key="financeiroValoresKey"
				:date="date">
			</financeiro-valores>
			<div class="row mt-4">
				<div class="col-xl-4 col-md-6 mb-4">
			    	<!-- chart despesa receita -->
			    	<financeiro-chart-pizza
			    		v-if="date"
			    		:key="financeiroChartPieKey" 
						:date="date">
					</financeiro-chart-pizza>
			    </div>
			    <div class="col-xl-8 col-md-6 mb-4">
			    	<financeiro-chart-bar
			    		v-if="date"
			    		:key="financeiroChartBarKey" 
						:date="date">
					</financeiro-chart-bar>
			    </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				date: '',
				financeiroCaixaKey: 1,
				financeiroValoresKey: 2,
				financeiroChartPieKey: 3,
				financeiroChartBarKey: 4
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			reload(){
				this.financeiroCaixaKey += 1;
				this.financeiroValoresKey += 1;
				this.financeiroChartPieKey += 1;
				this.financeiroChartBarKey += 1;
			}
		}
	}
</script>